import { render, staticRenderFns } from "./AvisEtRecoComponent.vue?vue&type=template&id=1039c902&scoped=true"
import script from "./AvisEtRecoComponent.vue?vue&type=script&lang=js"
export * from "./AvisEtRecoComponent.vue?vue&type=script&lang=js"
import style0 from "./AvisEtRecoComponent.vue?vue&type=style&index=0&id=1039c902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1039c902",
  null
  
)

export default component.exports